<template>
	<div class="table-container" style="width: 100%;padding: 20px;">
		<div style="display: flex;padding-bottom: 20px;align-items: center;justify-content: space-between;">
			<div style="display: flex;">
				<v-select v-model="searchProjectId" :items="projectsOptions" style="max-width: 250px;margin-right:20px;"
					item-text="name" item-value="id" menu-props="auto" hide-details label="项目" single-line
					class="mx-3 mb-3"></v-select>
				<v-text-field v-model="searchName" label="小区名称" style="max-width: 200px;margin-right:20px;" hide-details
					single-line class="mx-3 mb-3" />
			</div>
			<div style="display: flex;">
				<v-btn @click="resetQuery" color="primary" class="mx-3">
          重置
          <v-icon right>mdi-lock-reset</v-icon>
        </v-btn>
				<v-btn @click="getList" color="primary" class="mx-3">
					查询
					<v-icon right>mdi-magnify</v-icon>
				</v-btn>
				<v-btn color="green" dark @click="addShow">
					新增小区 <v-icon right>mdi-plus</v-icon>
				</v-btn>
			</div>
		</div>
		<v-data-table :items="items" :headers="headers" hide-default-footer>
			<template v-slot:item="{ item }">
				<tr>
					<td>{{ item.project_id }}</td>
					<td>{{ item.id }}</td>
					<td>{{ item.garden_name }}</td>
					<td>
						{{ item.start_date.substring(0, 10) }}
					</td>
					<td>{{ item.end_date.substring(0, 10) }}</td>
					<td>
						<v-icon @click="openStartDialog(item)" right color="green" title="修改开始时间"
							style="width: 40px;cursor:pointer;margin-right: 20px;">mdi-text-box-outline</v-icon>
						<v-icon @click="openEndDialog(item)" right color="red" title="修改结束时间"
							style="width: 40px;cursor:pointer;margin-right: 20px;">mdi-text-box-outline</v-icon>
						<v-icon left color="red" @click="removeGarden(item)" title="删除小区"
							style="width: 40px;cursor:pointer;">mdi-delete</v-icon>
					</td>
				</tr>
			</template>
		</v-data-table>
		<div class="pagination" style="margin-top: 20px;">
			<v-pagination v-model="page" @input="paginationChangeHandler" :circle="true" :length="total_pages"
				rounded="circle"></v-pagination>
		</div>
		<v-dialog v-model="dialogVisible" max-width="500px">
			<v-card style="text-align: center;">
				<v-card-text class="pa-4">
					<div style="color: #fff;font-size: 20px;margin-bottom: 20px;">{{ dateValue }}</div>
					<v-date-picker no-title v-model="dateValue" @input="handleChangeDate"></v-date-picker>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="#999" text @click="dialogVisible = false">取消</v-btn>
					<v-btn color="primary" @click="handleConfirm">确认</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="addDialogVisible" max-width="500px">
			<v-card style="text-align: center;">
				<v-card-text class="pa-4">
					<v-select v-model="addId" :items="projectsOptions" item-text="name" item-value="id" menu-props="auto"
						hide-details label="项目" single-line class="mx-3 mb-3"></v-select>
					<v-text-field v-model="garden_name" label="小区名称" hide-details single-line class="mx-3 mb-3" />
					<v-menu v-model="start_menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
						offset-y>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field v-model="addStartDate" label="开始时间" prepend-icon="mdi-calendar" readonly v-bind="attrs"
								v-on="on"></v-text-field>
						</template>
						<v-date-picker v-model="addStartDate" @input="start_menu = false"></v-date-picker>
					</v-menu>
					<v-menu v-model="end_menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
						offset-y>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field v-model="addEndDate" label="结束时间" prepend-icon="mdi-calendar" readonly v-bind="attrs"
								v-on="on"></v-text-field>
						</template>
						<v-date-picker v-model="addEndDate" @input="end_menu = false"></v-date-picker>
					</v-menu>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="#999" text @click="addDialogVisible = false">取消</v-btn>
					<v-btn color="primary" @click="handleAdd">确认</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-snackbar v-model="snackbar" timeout="2000"> {{ text }}</v-snackbar>
	</div>
</template>

<script>
import { getTransitionFeeSetting, putTransitionFeeSetting, addTransitionFeeSetting, delTransitionFeeSetting } from "@/api/transitionFeeDate";
import { fetchProjectsList } from "@/api/projects";

export default {
	name: "feedate",
	components: {},

	data: () => ({
		searchProjectId: '',
		searchName: '',
		total_pages: 0,
		page: 1,
		limit: 10,
		addId: '',
		garden_name: '',
		projectsOptions: [],
		addDialogVisible: false,
		end_menu: '',
		start_menu: '',
		addStartDate: '',
		addEndDate: '',
		snackbar: false,
		text: '',
		dialogVisible: false,
		selectItem: '',
		dateValue: '',
		headers: [
			{ text: '项目ID', value: 'project_id', sortable: false },
			{ text: 'ID', value: 'id', sortable: false },
			{ text: '小区名称', value: 'garden_name', sortable: false },
			{ text: '开始时间', value: 'start_date', sortable: false },
			{ text: '结束时间', value: 'end_date', sortable: false },
			{ text: '操作', sortable: false }
		],
		items: [],
		currentData: {}
	}),

	created() {
		this.getList();
		this.getProjectList();
	},
	watch: {
		addDialogVisible(val) {
			this.addId = '';
			this.garden_name = '';
			this.addStartDate = '';
			this.addEndDate = '';
		}
	},
	methods: {
		async getList() {
			let query = {
				page: this.page,
				limit: this.limit,
				garden_name: this.searchName,
				project_id: this.searchProjectId
			}
			if(this.searchName.length == 0) {
				delete(query.garden_name)
			}
			if(this.searchProjectId.length == 0) {
				delete(query.project_id)
			}
			const res = await getTransitionFeeSetting(query);
			this.items = res.data.items || [];
			this.total_pages = res.data._meta.total_pages
		},
		openStartDialog(item) {
			this.dialogVisible = true;
			this.dateValue = item.start_date.substring(0, 10);
			this.currentData = { ...item };
			this.selectItem = 'start';
		},
		openEndDialog(item) {
			this.dialogVisible = true;
			this.dateValue = item.end_date.substring(0, 10);
			this.currentData = { ...item };
			this.selectItem = 'end';
		},
		async handleConfirm() {
			this.dialogVisible = false;
			try {
				let res = await putTransitionFeeSetting(this.currentData);
				if(res.error){
					this.snackbar = true;
					this.text = '修改失败';
				}else {
					this.snackbar = true;
					this.text = '修改成功';
				}
				this.getList();
			} catch (error) {
				this.snackbar = true;
				this.text = '修改失败';
			}
		},
		handleChangeDate() {
			this.selectItem == 'start' ? this.currentData.start_date = this.dateValue : this.currentData.end_date = this.dateValue;
		},
		addShow() {
			this.addDialogVisible = true;
			this.addId = '';
		},
		getProjectList() {
			fetchProjectsList().then(response => {
				this.projectsOptions = response.data.items;
			});
		},
		async handleAdd() {
			let data = {
				project_id: this.addId,
				garden_name: this.garden_name,
				start_date: this.addStartDate,
				end_date: this.addEndDate
			}
			if (this.garden_name.trim().length == 0) {
				this.snackbar = true;
				this.text = '请输入小区名称';
				return
			} else if (this.addId.length == 0) {
				this.snackbar = true;
				this.text = '请选择项目';
				return
			} else if (this.addStartDate.length == 0) {
				this.snackbar = true;
				this.text = '请选择开始时间';
				return
			} else if (this.addEndDate.length == 0) {
				this.snackbar = true;
				this.text = '请选择结束时间';
				return
			} else {
				let timeStart = new Date(this.addStartDate),
					timeEnd = new Date(this.addEndDate);
				if (timeStart >= timeEnd) {
					this.snackbar = true
					this.text = '结束时间需要晚于开始时间';
					return
				}
			}
			try {
				let res = await addTransitionFeeSetting(data);
				this.snackbar = true;
				this.text = '新增成功';
				this.addDialogVisible = false;
				this.getList();
			} catch (error) {
				this.snackbar = true;
				this.text = '新增失败';
			}
		},
		removeGarden(item) {
			let id = item.id
			this.$confirm("确认删除?").then(res => {
				if (res) {
					delTransitionFeeSetting(id).then(response => {
						if (response.data.error) {
							this.text = "删除失败！";
							this.snackbar = true;
						} else {
							this.text = "删除成功！";
							this.snackbar = true;
							this.getList();
						}
					});
				}
			});
		},
		paginationChangeHandler(pageNumber) {
			this.page = pageNumber;
			this.getList();
		},
		resetQuery() {
			this.searchProjectId = '';
			this.searchName = '';
			this.page = 1;
			this.getList();
		}
	}
};
</script>

<style lang="scss" scoped>
table,
thead,
tr {
	color: #fff;
	font-weight: 400;
}

.background-transparent {
	background-color: transparent !important;
}

tr:hover {
	background-color: #0282b4 !important;
	color: rgb(224, 221, 221);
}
</style>